import React from "react";
import { useLang } from "../context/LanguageContext";
import { contactInfo } from "../mock";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const { t } = useLang();
  return (
    <a
      href={contactInfo.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-3 shadow-xl hover:scale-105 transition-transform group"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:block text-sm font-600 max-w-0 group-hover:max-w-xs overflow-hidden whitespace-nowrap transition-all duration-300">
        {t.whatsapp}
      </span>
    </a>
  );
}
